import React, { useState } from "react";
import userApi from "../../services/api/userApi";
import { jwtDecode } from "jwt-decode";
import { useIntl } from "react-intl";
import useChat from "../../stores/useChat.js";
import Evalogo from "../../images/EVA.png";
import Mundo365 from '../../images/Mundo-365-Parceiro-Microsoft-do-Brasil.png';

import {
  LoginPage,
  FormSide,
  InfoSide,
  GlassCard,
  NoiseOverlay,
  Subtitle,
  Form,
  InputGroup,
  Input,
  Label,
  SubmitButton,
  ErrorMessage,
  Footer,
  AiBadge
} from "./Login.js";

const Login = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { loadSettingsFromAPI } = useChat();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await userApi.login(email, password);
      const { token } = response.data;
      const decoded = jwtDecode(token);

      onLoginSuccess(token, decoded?.user_id, decoded?.roles);
      loadSettingsFromAPI();
    } catch (err) {
      setError("As credenciais informadas não coincidem.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoginPage>
      <InfoSide>
        <NoiseOverlay />
        <div className="info-wrapper">
          <AiBadge>Sistema Ativo de I.A.</AiBadge>

          <GlassCard>

            <h3>
              <span className="hl">E</span>ngine
              <span className="hl"> V</span>irtual <br />
              <span className="hl"> A</span>ttendant
            </h3>
            <p>
              A próxima fronteira da interação digital.
              Sua plataforma de atendimento potencializada por modelos de linguagem avançados.
            </p>

            <div className="stat" style={{ marginTop: '40px' }}>
              <span className="value">+80%</span>
              <span className="label">Performance Operacional</span>
            </div>
          </GlassCard>
        </div>
      </InfoSide>

      <FormSide>
        <div className="content">
          <header>
            <img src={Evalogo} alt="EVA Logo" />
            <Subtitle>
              Insira seus dados para acessar o painel administrativo.
            </Subtitle>
          </header>

          <Form onSubmit={handleLogin}>
            <ErrorMessage className={error ? "show" : ""}>
              {error}
            </ErrorMessage>

            <InputGroup>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=" "
                required
              />
              <Label>E-mail corporativo</Label>
            </InputGroup>

            <InputGroup>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=" "
                required
              />
              <Label>Senha</Label>
            </InputGroup>

            <SubmitButton type="submit" disabled={isLoading}>
              {isLoading ? "Autenticando..." : "Entrar na plataforma"}
            </SubmitButton>
          </Form>

          <Footer>
            <span>Powered by</span>
            <img src={Mundo365} alt="Mundo 365" />
          </Footer>
        </div>
      </FormSide>
    </LoginPage>
  );
};

export default Login;